import { MaterialsCard } from "@components/MaterialsCard/MaterialsCard";
import { CardImpression } from "@jmc/core/src/components";
import { CMSMaterialsCardProps } from "@jwm/types/CMSMaterialsCardProps";
import { default as cmsMapper } from "@utils/cms-mapper";
import React from "react";

import { trackingHelpersProps } from "../../types";

interface MaterialsCardBlockProps {
    component: CMSMaterialsCardProps;
    placement: string;
    trackingHelpers: trackingHelpersProps;
    sectionIndex?: number;
    siteSpecialty?: {
        type: string;
        title: string;
    };
}

export const MaterialsCardBlock = ({
    component,
    placement,
    trackingHelpers,
    sectionIndex = 0,
    siteSpecialty,
}: MaterialsCardBlockProps): JSX.Element => {
    const materialsCardProps = cmsMapper.mapMaterialsCardProps(component);
    return (
        <CardImpression
            type="materials"
            name={materialsCardProps?.title as string}
            placement={`${placement}|card:(${materialsCardProps?.title?.toString().toLowerCase()})`}
            position={trackingHelpers.position}
            targeturl={materialsCardProps?.fileUrl}
        >
            <MaterialsCard
                {...materialsCardProps}
                loading={sectionIndex === 0 ? "eager" : "lazy"}
                siteSpecialty={siteSpecialty}
            />
        </CardImpression>
    );
};
